<template>
    <div class="MemoryIQView" :class="{ boxExpaned: !boxCollapsed, popupSticksToBottom }">
        <div class="header">
            <div class="exitButton --global-clickable" @click="exit()">
                <svgicon class="svg-icon" icon="close" />
            </div>
        </div>
        <div class="title">
            {{ $t('title') }}
        </div>
        <!-- <div class="subtitle">{{ $t('subtitle') }}</div> -->

        <div class="spacer" />

        <Results @animation-completed="onResultAnimated()" />

        <div class="spacer" />

        <div ref="boxHeight" class="boxHeight" />
        <div class="box" :class="{ collapsed: boxCollapsed }" @click.self="boxCollapsed = true">
            <component
                :is="modalComponent"
                ref="popup"
                class="boxInner"
                :collapsed="boxCollapsed"
                @request-expand="boxCollapsed = false"
                @request-collapse="boxCollapsed = true"
            />
        </div>
    </div>
</template>

<translations>
  tagline: 'The Memory Challenge'
  title: 'Memory IQ'
  title_no: 'Hukommelses-IQ'
  subtitle: 'Test your working memory and learn a fun system that can double your creative memory'
  subtitle_no: 'Test arbeidshukommelsen og lær en morsom teknikk som dobler din kreative hukommelse'
</translations>

<script>
import WorkingMemory from '../components/WorkingMemory';
import CreativeMemory from '../components/CreativeMemory';
import BonusKnowledge from '../components/BonusKnowledge';
import Results from '../components/Results';

export default {
    components: { Results },
    data() {
        return {
            boxCollapsed: true,
            popupSticksToBottom: true
        };
    },
    computed: {
        partADone() {
            return !!this.$store.state.moduleMemogenius.settings.memoryOnboardingTestA;
        },
        partBDone() {
            return !!this.$store.state.moduleMemogenius.settings.memoryOnboardingTestB;
        },
        modalComponent() {
            if (this.partADone && this.partBDone) {
                return BonusKnowledge;
            } else if (this.partADone) {
                return CreativeMemory;
            } else {
                return WorkingMemory;
            }
        }
    },
    mounted() {
        const collapsedHeight = this.$refs.popup.getCollapsedHeight();
        this.$refs.boxHeight.style.height = `${collapsedHeight}px`;
    },
    methods: {
        toggleBox() {
            this.boxCollapsed = !this.boxCollapsed;
        },
        exit() {
            this.$router.push({
                name: 'DashboardHomeView'
            });
        },
        onResultAnimated() {
            const collapsedHeight = this.$refs.popup.getCollapsedHeight();
            this.$refs.popup.$el.style.transform = `translateY(${
                this.popupSticksToBottom ? 100 : 50
            }%) translateY(-${collapsedHeight}px)`;
        }
    }
};
</script>

<style lang="scss" scoped>
$transitionDuration: 0.5s;

.MemoryIQView {
    background-color: #101553;
    background-image: url('./background.jpg');
    background-size: cover;
    background-position: center;
    color: white;
    display: flex;
    flex-direction: column;

    & > *:not(.box) {
        transition: opacity $transitionDuration;
    }

    &.boxExpaned {
        & > *:not(.box) {
            opacity: 0;
        }
    }

    &.popupSticksToBottom {
        .box {
            transform: translateY(0%);
            justify-content: flex-end;
            padding-bottom: 0;
        }
        .boxInner {
            transform: translateY(100%);
            border-radius: 1em 1em 0 0;
        }
    }
}

.header {
    height: $topBarHeight;
    display: flex;
    justify-content: flex-end;
}
.exitButton {
    padding: 1em;
    display: flex;
    align-items: center;
    .svg-icon {
        $size: 0.8em;
        display: block;
        width: $size;
        height: $size;
        fill: rgba(white, 0.7);
    }
}

.title {
    font-size: 200%;
    text-align: center;
    color: rgba(white, 0.9);
}
.subtitle {
    color: rgba(white, 0.7);
    max-width: 23em;
    line-height: 1.5em;
    text-align: center;
    margin: auto;
    margin-top: 1em;
}

.spacer {
    flex: 1;
}

.box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: transform $transitionDuration;
    padding: 1em;

    &.collapsed {
        transform: translateY(50%);
        pointer-events: none;
    }
    &:not(.collapsed) {
        .boxInner {
            transform: translateY(0) !important;
        }
    }
}
.boxInner {
    pointer-events: all;
    width: 100%;
    max-width: 40em;
    max-height: 90%;
    transition: transform $transitionDuration;
    transform: translateY(50%);
}
</style>
